import { NgModule } from '@angular/core';
import { PrettyJsonPipe } from './prettyJsonPipe';

@NgModule({
	declarations: [PrettyJsonPipe],
	imports: [],
	exports: [PrettyJsonPipe],
	providers: [],
})
export class PrettyJsonPipeModule {}
